import * as React  from "react";
import {getCsrfToken} from './../../../commons/authenticityToken'

const Purchase = (props) => {
  return (
    <>
      <h3>チケット購入</h3>
      <br/>
      <form name="messages_update_form" action="/tickets/data/confirm" acceptCharset="UTF-8" method="post">
      <input name="authenticity_token" type="hidden" value={getCsrfToken()} />
      <div className="table-responsive message-table-content">
        <table id="notice_table" className="table table-bordered">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center col-lg-2">チケット名</th>
              <th scope="col" className="text-center col-lg-2">枚数</th>
              <th scope="col" className="text-center col-lg-2">有効日数</th>
              <th scope="col" className="text-center col-lg-2">価格</th>
              <th scope="col" className="text-center col-lg-2">購入するセット数</th>
            </tr>
          </thead>
          <tbody>
              {props.m_tickets.map((ticket, i) => (
                  <tr key={i}>
                    <td className="text-center va_middle">{ticket.name}</td>
                    <td className="text-center va_middle">{ticket.issue_number.toLocaleString()}</td>
                    <td className="text-center va_middle">{ticket.valid_period_day.toLocaleString()}日</td>
                    <td className="text-center va_middle">{ticket.price.toLocaleString()}円</td>
                    <td className="text-center va_middle">
                        <div className="form-group">
                          <div className="col-sm-3"></div>
                          <div className="col-sm-5">
                            <input className="form-control"
                                  id="inputPurchaseCount"
                                  type="number"
                                  min={1}
                                  name={"m_ticket[" + ticket.id + "]" + "purchase_count"}
                                  placeholder="1"
                                  disabled={!props.is_admin}>
                                  
                            </input>
                          </div>
                        </div>
                    </td>
                  </tr>
              ))}
          </tbody>
        </table>
        {props.m_tickets.map((ticket, i) => (
          <div key={i}>
            <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "id"} value={ticket.id}></input>
            <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "issue_number"} value={ticket.issue_number}></input>
            <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "name"} value={ticket.name}></input>
            <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "valid_period_day"} value={ticket.valid_period_day}></input>
            <input type="hidden" name={"m_ticket[" + ticket.id + "]" + "price"} value={ticket.price}></input>
          </div>))}
        <input type="hidden" name="company_id" value={props.company_id}></input>
        <input type="submit"
               value="購入内容確認画面に進む"
               className="btn btn-primary pull-right form-btn"
               data-disable-with="購入内容確認画面に進む" 
               disabled={!props.is_admin} />
      </div>
      </form>
    </>
  )
}

export default Purchase
